import React from 'react';
import { Button, List, Tag } from 'antd';

const ListDealBanners = ({ bannerData, isLoading, onEdit, onDelete }) => {
  return (
    <div>
      <List
        itemLayout="horizontal"
        dataSource={bannerData}
        loading={isLoading}
        renderItem={(card, index) => (
          <List.Item
            actions={[
              <Button key="edit" onClick={() => onEdit(card)}>
                Edit
              </Button>,
              <Button key="edit" onClick={() => onDelete(card)} className='bg-red text-white'>
                Delete
              </Button>,
            ]}
          >
            <List.Item.Meta
              description={
                <div className="flex justify-between items-center">
                  {card.desktopImage ? (
                    <div className="flex flex-col">
                      Desktop
                      <img
                        src={card.desktopImage}
                        alt="img"
                        className="w-full object-contain h-[100px]"
                      />
                    </div>
                  ) : (
                    ''
                  )}

                  {card.mobileImage ? (
                    <div className="flex flex-col">
                      Mobile
                      <img
                        src={card.mobileImage}
                        alt="img"
                        className="w-full object-contain h-[100px]"
                      />
                    </div>
                  ) : (
                    ''
                  )}

                  {card.position && (
                    <Tag
                      color={
                        card.position === 'first'
                          ? 'purple'
                          : card.position === 'second'
                          ? 'red'
                          : 'green'
                      }
                      style={{ marginLeft: '10px' }}
                      className="h-[25px]"
                    >
                      {card.position}
                    </Tag>
                  )}
                </div>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default ListDealBanners;
